import { render } from "./KoiForm.vue?vue&type=template&id=23c766ce&scoped=true&ts=true"
import script from "./KoiForm.vue?vue&type=script&lang=ts"
export * from "./KoiForm.vue?vue&type=script&lang=ts"

import "./KoiForm.vue?vue&type=style&index=0&id=23c766ce&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c766ce"]])

export default __exports__